import { render, staticRenderFns } from "./SelectDeliveryOrder.vue?vue&type=template&id=67ac31df&"
import script from "./SelectDeliveryOrder.vue?vue&type=script&lang=js&"
export * from "./SelectDeliveryOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports